<template>
    <div class="syccxhz" v-loading="loading">
        <div class="syccxhzHeader">
            <!--          <div></div>-->
            <div class="sycBottom">
                <p>{{date[0]}}年{{date[1]}}月份汽车分企业出口情况表</p>
            </div>
            <div class="sycDan">
                <p>单位：辆，%</p>
            </div>
        </div>
        <div>
            <table border="1" style="width: 100%;padding: 5px" class="hisTable" id="tal">
                <thead>
                    <tr class="headerClass">
                        <td>序号</td>
                        <td>企业</td>
                        <td>{{date[0]}}-{{date[1]}}出口量</td>
                        <td>{{date[0]}}01-{{date[1]}}出口量</td>
                        <td>{{date[0]-1}}01-{{date[1]}}出口量</td>
                        <td>同比增速</td>
                        <td>环比增速</td>
                        <td>累计增速</td>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in tableData" :key="index">


                        <td>{{ item.zhibiao=='总计'?" ":index}}</td>
                        <td>{{item.zhibiao}}</td>
                        <td>{{item.ckliang}}</td>
                        <td>{{item.ljckliang}}</td>
                        <td>{{item.ljtqckliang}}</td>

                         <td>{{item.tbzs}}</td>
                        <td>{{item.hbzs}}</td>
                        <td>{{item.ljzs}}</td>

                        
                    </tr>
                </tbody>

            </table>
        </div>
    </div>
</template>
<script>
import { getQcfqyckqkb } from "@/api/data";
import { combineCell } from "@/utils/tableData.js";
export default {
    data() {
        return {
            tableData: [],
            date: null,
            loading:true
        };
    },
    created() {
        let date = this.$route.params.date;
        this.date = date.split("-");
        this.getQcfqyckqkb(date.split("-").join(""));
    },
    methods: {
        getQcfqyckqkb(date) {
            getQcfqyckqkb({ dataDate: date }).then((res) => {
                if (res.code == 200) {
                    this.tableData = combineCell(res.data);
                }
                 this.loading = false
            });
        },
    },
};
</script>
<style scoped lang="css">
.hisTable {
    font-size: 15px;
    text-align: center;
    margin-top: 10px;
}
.headerClass {
    font-size: 16px;
    color: white;
    background-color: #0d57bc;
}
.trOne {
    font-weight: bold;
}
.syccxhzHeader {
    width: 100%;
    height: 90px;

    font-size: 22px;
    text-align: center;
}
.sycBottom {
    width: 100%;
    height: 70px;
    line-height: 70px;

    float: right;
    font-weight: bold;
}
.sycDan {
    width: 10%;
    height: 20px;

    float: right;
    font-size: 13px;
}
</style>